import { FieldHelper } from "./FieldHelper.js";
class TemporalFieldHelper extends FieldHelper {
  setToNow(options) {
    this.getAccessor().updateValue(new Date().toISOString(), options);
  }
}
((TemporalFieldHelper2) => {
  TemporalFieldHelper2.setToNow = (field, options) => {
    new TemporalFieldHelper2(field).setToNow(options);
  };
})(TemporalFieldHelper || (TemporalFieldHelper = {}));
export {
  TemporalFieldHelper
};
//# sourceMappingURL=TemporalFieldHelper.js.map
